import ReliableCollaborationServer from './ReliableCollaborationServer';

const defaultCollaborationServer = {};

export function getCollaborationServer(urlOptions = {}, editorVersion = 1) {
  let collaborationServer;
  if (![1, 2].includes(editorVersion)) editorVersion = 1;

  if (!urlOptions.baseURL) {
    if (!defaultCollaborationServer[editorVersion]) {
      defaultCollaborationServer[editorVersion] =
        new ReliableCollaborationServer();
    }
    collaborationServer = defaultCollaborationServer[editorVersion];
  } else {
    collaborationServer = new ReliableCollaborationServer(urlOptions);
  }

  return collaborationServer;
}

export function getCollaborationSocket(collaborationServer) {
  if (!collaborationServer.socket) {
    collaborationServer.connect();
  }

  return collaborationServer.socket;
}
